var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryCar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Car"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9230769,20.8825021 L39.1166526,11.5502959 C38.4742181,9.42011834 36.5469146,8 34.3491124,8 L15.5832629,8 C13.3516484,8 11.4243449,9.42011834 10.8157227,11.5502959 L8.00929839,20.8825021 C6.25105664,21.660186 5,23.4184277 5,25.4471682 L5,35.421809 C5,36.808115 6.11580727,37.9239222 7.50211327,37.9239222 L7.50211327,37.9239222 L7.50211327,40.4260355 C7.50211327,41.8123415 8.61792054,42.9281488 10.0042265,42.9281488 L12.5063398,42.9281488 C13.8926458,42.9281488 15.0084531,41.8123415 15.0084531,40.4260355 L15.0084531,37.9239222 L34.9915469,37.9239222 L34.9915469,40.4260355 C34.9915469,41.8123415 36.1073542,42.9281488 37.4936602,42.9281488 L39.9957735,42.9281488 C41.3820795,42.9281488 42.4978867,41.8123415 42.4978867,40.4260355 L42.4978867,37.9239222 L42.4978867,37.9239222 L42.4978867,37.9239222 C43.8841927,37.9239222 45,36.808115 45,35.421809 L45,25.4471682 C44.9323753,23.3846154 43.6813187,21.6263736 41.9230769,20.8825021 L41.9230769,20.8825021 Z M15.5832629,12.9704142 L34.3491124,12.9704142 L36.580727,20.476754 L13.317836,20.476754 L15.5832629,12.9704142 L15.5832629,12.9704142 Z M14.9746407,31.7024514 C13.5883347,31.7024514 12.4725275,30.5866441 12.4725275,29.2003381 C12.4725275,27.8140321 13.5883347,26.6982249 14.9746407,26.6982249 C16.3609467,26.6982249 17.476754,27.8140321 17.476754,29.2003381 C17.476754,30.5866441 16.3609467,31.7024514 14.9746407,31.7024514 Z M34.9577346,31.7024514 C33.5714286,31.7024514 32.4556213,30.5866441 32.4556213,29.2003381 C32.4556213,27.8140321 33.5714286,26.6982249 34.9577346,26.6982249 C36.3440406,26.6982249 37.4598478,27.8140321 37.4598478,29.2003381 C37.4260355,30.5866441 36.3102282,31.7024514 34.9577346,31.7024514 Z",
    id: "Shape",
    fill: "#1B7690",
    fillRule: "nonzero"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-car.31bbf3afc7f1ccdc4fc9333d7001737c.svg";